import React, { useState } from "react";
import './Home.css';
import { useEffect } from "react";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import { SingleStat } from "./SingleStat";
import { DashboardThree } from "./DashboardThree";
import * as Dashboard from '../../Services/DashboardDB'
import {KRAInfo} from "../EmployeeInformation/KRAInfo"
import { EditInfo } from "../EmployeeInformation/EditInfo";
import { AuditInfo } from "../EmployeeInformation/AuditInfo";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import * as userManager from '../../Services/UserSessionManager';
import { EmployeeDetails } from "../EmployeeInformation/EmployeeDetails";
import { AuditTrialVM } from "../../Models/ViewModels";
import * as Audit from "../../Services/EmployeeDB";
import * as EmployeeData from "../../Services/EmployeeDB";
import { MyTeamInfo } from "../EmployeeInformation/MyTeamInfo";

ChartJS.register(ArcElement, Tooltip, Legend);

export const Home = () => {
    const [totalemp, setTotalemp] = useState();
    const [city, setCity] = useState([]);
    const [audit, setAudit] = useState(new Array<AuditTrialVM>());
    
    const [uploadDate, setUploadDate] = useState("");
    const[loginid,setLoginid]=useState(GetUserLoginID())
    const [checkRole,setCheckRole]=useState(userManager.GetUserRole());
    useEffect(() => {
        
        Dashboard.GetDashboardStats(loginid).then((res: any) => {
            setTotalemp(res.data.TotalEmployees)
            setCity(res.data.Cities);
            
            Audit.GetAuditDetails(loginid).then((resp:any) => {
                setAudit(resp.data);
            })
            GetUploadDate()
        })
    }, [])
    const GetUploadDate=()=>{
        EmployeeData.GetLastUploaded().then((resp) => {
            const [year, month, day] = resp.data.split('-');
            let newDate = `${day}-${month}-${year}`;
         setUploadDate(newDate)
      });
    }
    return (
        <div>
             {checkRole=='H' || checkRole=='PM'|| checkRole=='M'|| checkRole=='BI'|| checkRole=='A'||checkRole=='QM'?
             <div>
            <div className="d-flex justify-content-center border-bottom">

                {city && city.map((data: any) => {
                  return(
                    <div>
                        {data.CityName!="TOTAL"?
                    <div className="border-end px-3">
                        <SingleStat title={data.CityName} value={data.TotalCount} />
                    </div>:<></>}
                    </div>
                  )
                })
                }             
                {city && 
                <div className="border-end px-3">
                    <SingleStat title="TOTAL EMPLOYEES" value={totalemp} />
                </div>}
            </div>

            <div className="row row-cols-auto gap-4 justify-content-md-center mt-4">
                {city && city.map((data: any) => {
                    return (
                        <div className="col text-center p-4">
                            <h2 className="stems-green-text">{data.CityName}</h2>
                            <DashboardThree city={data} />
                        </div>
                    )
                })}
        
            </div>
            <p className="float-end"><b>Last Updated On :</b>{uploadDate}</p>
            </div>
            :<div>
                 <div>
    <div className="row">
        
<div className="col-4"><EmployeeDetails id={loginid} /></div>
<div className="col-2"><EditInfo id={loginid} /></div>
<div className="col-6"><KRAInfo id={loginid} /><br/>
<MyTeamInfo id={loginid}  /><br/>

<AuditInfo data={audit} /></div>    
</div>
</div></div>}
        </div>
    )
}
